import React, { useMemo, useRef, useEffect, useState } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { Popconfirm, Button, Input, Space } from 'antd';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import notification from '@iso/components/Notification';
import respostasRapidasApi from '@iso/services/repository/respostasRapidas';
import { canAccessModule, b64_to_utf8, utf8_to_b64 } from '@iso/lib/helpers/utility';
import TableWrapper from '../../Tables/AntTables/AntTables.styles';
import CardWrapper, { Box } from '../../Registration/IntegrationRule/IntegrationRule.styles';
import HelperText from '@iso/components/utility/helper-text';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import PageTitleActions from '@iso/containers/Dashboard/PageTitleActions';
import FormWindow from '@iso/containers/Dashboard/FormWindow';
import FastResponseEdit from './WhatsAppFastResponseEdit';
import Scrollbars from '@iso/components/utility/customScrollBar';

import Loader from '@iso/components/utility/loader';

export default function () {

  const match = useRouteMatch();

  const ses = sessionStorage.getItem("permissions");
	const userCo = localStorage.getItem("userCo");
	const arraySplit = b64_to_utf8(ses).split(",");

  const [selected, setSelected] = useState([]);

  const [editingId, setEditingId] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const [initialResponses, setinitialResponses] = useState(false);
  const [respostasrapidas, setRespostasRapidas] = useState([]);

  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex, collum) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, collum)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, collum)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        title={"Pesquisar pelo " + dataIndex + " da Nota Fiscal"}
        style={{
          color: '#000000',
        }}
      />
    ),
    onFilter: (value, record) => {
      return record[collum]?.toString().toLowerCase().includes(value.toLowerCase())
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === collum ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  useEffect(() => {
    getRespostasRapidas();
  }, []);

  const getRespostasRapidas = () => {
    respostasRapidasApi.getAllRespostasRapidas().then(async (response) => {
      setRespostasRapidas(response.data);
      sessionStorage.setItem('auxFastResponses', utf8_to_b64(JSON.stringify(response.data)));
      setinitialResponses(true);
    })
    .catch((err) => {
      console.error(err);
    });
  }

  const columns = useMemo(() => [
    {
      title: 'Código',
      dataIndex: 'code',
      key: 'code',
      width: '30%',
      render: (text) => <span>{text}</span>,
      ...getColumnSearchProps('Código', 'code')
    },
    {
      title: 'Usuário',
      dataIndex: 'user',
      key: 'user',
      width: '30%',
      render: (text) => <span>{text}</span>,
      ...getColumnSearchProps('Tipo', 'user')
    },
    {
      title: 'Tipo',
      dataIndex: 'type',
      key: 'type',
      width: '10%',
      render: (text) => <span>{text}</span>,
      ...getColumnSearchProps('Tipo', 'type')
    },
    {
      title: 'Visibilidade',
      dataIndex: 'scope',
      key: 'scope',
      width: '10%',
      render: (text) => <span>{text}</span>,
      ...getColumnSearchProps('Visibilidade', 'scope')
    },
    {
      title: 'Status',
      dataIndex: 'situation',
      key: 'situation',
      width: '10%',
      render: (text) => {
        return <span>{text}</span>;
      }
    },
    {
      title: '',
      dataIndex: 'view',
      key: 'view',
      width: '10%',
      render: (_, respostarapida) => {
        return (
          <div className="isoPeopleBtnView">
            { (userCo === respostarapida.user_id || arraySplit.includes('all')) ? 
              <>
                <a href={`${match.path}/${respostarapida._id}`} onClick={(event) => { event.preventDefault(); setEditingId(respostarapida._id); }}>
                  <Button color="primary" className="productViewBtn">
                    Editar
                  </Button>
                </a>
                <Popconfirm title="Deseja realmente deletar?" onConfirm={() => {
                  respostasRapidasApi.softDeleteRespostaRapida(respostarapida._id).then(async (response) => {
                      if (response.data === 'ok') {
                        notification('success', 'Resposta rápida deletada');
                        getRespostasRapidas();
                      } else {
                        notification('error', 'Erro ao deletar resposta rápida');
                      }
                    }
                  )
                  .catch((err) => {
                    console.error("ops! ocorreu um erro" + err);
                  });
                }}>
                  <Button className="productDltBtn" onClick={() => { }}>
                    <i className="ion-android-delete" />
                  </Button>
                </Popconfirm>
              </> : '' }
          </div>
        );
      }
    }
  ]);

  const rowSelection = {
    hideDefaultSelections: true,
    selectedRowKeys: selected,
    onChange: (selected) => setSelected(selected),
    selections: [
      {
        rowKey: 'all-data',
        text: 'Selecionar todos',
        onSelect: () => setSelected(respostasrapidas.map((respostarapida) => respostarapida._id)),
      },
      {
        rowKey: 'no-data',
        text: 'Desselecionar',
        onSelect: () => setSelected([]),
      },
    ],
    onSelection: (selected) => setSelected(selected),
  };

  return (
    (canAccessModule("Whatsapp")) ?
      <LayoutWrapper>
        
        <PageTitleBar title="Respostas Rápidas WhatsApp" />
        <PageTitleActions primary={{ key: 'create', label: "Adicionar", onClick: () => setEditingId('0') }} />
        <Box style={{ border: 'none', boxShadow: 'none' }}>
          {!initialResponses ? (
            <Loader />
          ) : (
            <CardWrapper>
              {respostasrapidas !== undefined && respostasrapidas.length === 0 ? (
                <HelperText text="Respostas Rápidas" />
              ) : (
                <div className="isoPeopleTable">
                  <div
                    style={{ width: '100%', height: 'calc(100vh - 70px)' }}
                  >
                    <TableWrapper
                      rowKey={"_id"}
                      rowSelection={rowSelection}
                      dataSource={respostasrapidas}
                      columns={columns}
                      pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: ['10', '20', '50', '100'] }}
                      className="peopleListTable"
                    />
                  </div>
                </div>
              )}
            </CardWrapper>
          )}
        </Box>
            <FormWindow
        open={editingId !== null}
        title={editingId === '0' ? 'Cadastro de Resposta Rapida' : 'Edicao de Resposta Rapida'}
        onClose={() => setEditingId(null)}
      >
        {({ footerEl }) =>
          editingId !== null ? (
            <FastResponseEdit
              fastResponseId={editingId}
              inModal
              footerEl={footerEl}
              onCancel={() => setEditingId(null)}
              onSaved={() => {
                setEditingId(null);
                getRespostasRapidas();
              }}
            />
          ) : null
        }
      </FormWindow>
    </LayoutWrapper>
      : <></>
  );
}